import { c } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const ContentRight = (props) => (React.createElement(ContentRightStyled, { id: "content-right", open: props.leftNavOpen, rightNavOpen: props.rightNavOpen },
    props.children,
    props.rightNavOpen && React.createElement(Overlay, { onClick: () => c.local.toggleRightNav() })));
export default ContentRight;
const ContentRightStyled = styled.div `
  transition: all 0.1s;
  position: relative;
  left: 0;
  transform: ${(props) => props.rightNavOpen
    ? `translate3d(-${THEME.NAV_RIGHT_WIDTH}px, 0, 0)`
    : 'translate3d(0, 0, 0)'};
  height: 100vh;
  background-color: ${THEME.BACKGROUND};
  width: ${(props) => `calc(100% -  ${props.open ? THEME.NAV_LEFT_WIDTH : 0}px)`};
  float: right;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    width: 100%;
    transform: ${(props) => `translate3d(${props.open
    ? THEME.NAV_LEFT_WIDTH
    : props.rightNavOpen
        ? -THEME.NAV_RIGHT_WIDTH
        : 0}px, 0, 0)`}
`;
const Overlay = styled.div `
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: black;
  opacity: 0.2;
  top: 0;
  left: 0;
  cursor: pointer;
`;
//# sourceMappingURL=ContentRight.js.map